export default "__VITE_ASSET__CjEKkwWD__"